export interface Series {
  id: string;
  title: string;
  author: string;
  tags: string[];
  rating: number;
  chapters: number;
  status: string;
  update: string;
  description: string;
  cover: string;
}

export const categories = [
  "全部",
  "恋爱",
  "奇幻",
  "都市",
  "动作",
  "悬疑",
  "校园",
  "科幻",
  "冒险",
];

export const seriesList: Series[] = [
  {
    id: "moonfall",
    title: "月落星沉",
    author: "林间小鹿",
    tags: ["奇幻", "恋爱"],
    rating: 9.6,
    chapters: 128,
    status: "连载中",
    update: "今日更新",
    description:
      "身负星脉之力的少女在月蚀之夜醒来，为寻找失落的星钥踏上旅程。画风细腻、世界观宏大，一口气读完全集也停不下来。",
    cover: "https://readdy.ai/api/search-image?query=stylized%20webtoon%20manhwa%20cover%20of%20a%20melancholy%20girl%20with%20glowing%20starlight%20orbs%20under%20a%20crescent%20moon%2C%20ethereal%20fantasy%20mood%2C%20warm%20amber%20and%20deep%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20digital%20art&width=600&height=800&seq=series-01&orientation=portrait",
  },
  {
    id: "urban-ability",
    title: "都市异能者",
    author: "K工作室",
    tags: ["都市", "动作"],
    rating: 9.3,
    chapters: 210,
    status: "连载中",
    update: "昨日更新",
    description:
      "平凡上班族在一次雷雨中被闪电击中，意外觉醒了隔空取物异能。在都市阴影中与各方势力周旋，节奏紧凑、爽点密集。",
    cover: "https://readdy.ai/api/search-image?query=stylized%20webtoon%20cover%20of%20a%20confident%20young%20man%20in%20a%20city%20suit%20with%20electric%20lightning%20energy%20around%20his%20hands%2C%20urban%20night%20skyline%20background%2C%20warm%20amber%20and%20charcoal%20palette%2C%20clean%20dynamic%20composition%2C%20high%20detail&width=600&height=800&seq=series-02&orientation=portrait",
  },
  {
    id: "alchemist",
    title: "炼金术士的手札",
    author: "灰烬之书",
    tags: ["奇幻", "冒险"],
    rating: 9.5,
    chapters: 96,
    status: "连载中",
    update: "今日更新",
    description:
      "误入古籍王国的少年得到一本会说话的手札，从此踏上炼金之路。每一卷都是一个完整谜题，解谜与冒险交织，脑洞大开。",
    cover: "https://readdy.ai/api/search-image?query=stylized%20webtoon%20cover%20of%20a%20young%20alchemist%20with%20a%20glowing%20ancient%20tome%20and%20floating%20golden%20formulas%2C%20mystical%20laboratory%20background%2C%20warm%20amber%20light%2C%20clean%20fantasy%20composition%2C%20high%20detail&width=600&height=800&seq=series-03&orientation=portrait",
  },
  {
    id: "sword-contract",
    title: "剑与契约",
    author: "北境风骨",
    tags: ["动作", "冒险"],
    rating: 9.2,
    chapters: 154,
    status: "已完结",
    update: "全本完结",
    description:
      "落魄剑客与神秘契约者结伴闯荡大陆，一路上披荆斩棘。打斗分镜行云流水，是动作控不能错过的经典之作。",
    cover: "https://readdy.ai/api/search-image?query=stylized%20webtoon%20cover%20of%20a%20wandering%20swordsman%20holding%20a%20glowing%20sword%20amidst%20swirling%20ink%20and%20embers%2C%20epic%20fantasy%20warrior%20mood%2C%20warm%20amber%20and%20crimson%20palette%2C%20clean%20dynamic%20composition%2C%20high%20detail&width=600&height=800&seq=series-04&orientation=portrait",
  },
  {
    id: "summer-letter",
    title: "夏日告白信",
    author: "奶油汽水",
    tags: ["恋爱", "校园"],
    rating: 9.4,
    chapters: 72,
    status: "连载中",
    update: "今日更新",
    description:
      "一封寄错地址的告白信，牵起了两个平行班级的缘分。清新日常里藏着细水长流的悸动，甜度刚刚好。",
    cover: "https://readdy.ai/api/search-image?query=stylized%20webtoon%20cover%20of%20a%20blushing%20schoolgirl%20holding%20an%20envelope%20in%20a%20sunlit%20cherry%20blossom%20courtyard%2C%20romantic%20youth%20mood%2C%20warm%20peach%20and%20amber%20palette%2C%20clean%20soft%20background%2C%20high%20detail&width=600&height=800&seq=series-05&orientation=portrait",
  },
  {
    id: "doomsday",
    title: "末日救援队",
    author: "铁壁防线",
    tags: ["科幻", "动作"],
    rating: 9.0,
    chapters: 188,
    status: "连载中",
    update: "本周更新",
    description:
      "世界崩坏后，一支精英救援队在废墟中穿行，守护最后的希望。末世氛围浓厚，角色塑造立体。",
    cover: "https://readdy.ai/api/search-image?query=stylized%20webtoon%20cover%20of%20a%20rescue%20team%20in%20armored%20suits%20walking%20through%20a%20ruined%20city%20with%20searchlights%2C%20post%20apocalyptic%20mood%2C%20warm%20amber%20and%20dark%20grey%20palette%2C%20clean%20cinematic%20composition%2C%20high%20detail&width=600&height=800&seq=series-06&orientation=portrait",
  },
  {
    id: "king-returns",
    title: "王者归来",
    author: "孤灯夜谈",
    tags: ["动作", "都市"],
    rating: 9.1,
    chapters: 142,
    status: "已完结",
    update: "全本完结",
    description:
      "隐退多年的佣兵之王重回都市，只为守护故人。一路碾压反派、快意恩仇，爽度爆表。",
    cover: "https://readdy.ai/api/search-image?query=stylized%20webtoon%20cover%20of%20a%20powerful%20man%20in%20a%20long%20coat%20turning%20back%20over%20his%20shoulder%20with%20a%20city%20skyline%20behind%2C%20dominant%20confident%20mood%2C%20warm%20amber%20and%20black%20palette%2C%20clean%20dramatic%20composition%2C%20high%20detail&width=600&height=800&seq=series-07&orientation=portrait",
  },
  {
    id: "time-lover",
    title: "时光恋人",
    author: "碎月拾光",
    tags: ["恋爱", "都市"],
    rating: 9.3,
    chapters: 64,
    status: "连载中",
    update: "今日更新",
    description:
      "每天凌晨三点，女主角都会在旧书店遇见同一个男人。时间循环中的双向奔赴，宿命感拉满。",
    cover: "https://readdy.ai/api/search-image?query=stylized%20webtoon%20cover%20of%20a%20couple%20meeting%20in%20a%20cozy%20old%20bookstore%20with%20warm%20lamplight%20and%20floating%20time%20pieces%2C%20romantic%20melancholy%20mood%2C%20warm%20amber%20palette%2C%20clean%20intimate%20composition%2C%20high%20detail&width=600&height=800&seq=series-08&orientation=portrait",
  },
  {
    id: "star-scavenger",
    title: "星海拾荒者",
    author: "零重力",
    tags: ["科幻", "冒险"],
    rating: 8.9,
    chapters: 110,
    status: "连载中",
    update: "本周更新",
    description:
      "在银河边缘的废弃星带上，拾荒者少女捡到一艘来历不明的古老飞船，意外揭开宇宙深处的秘密。",
    cover: "https://readdy.ai/api/search-image?query=stylized%20webtoon%20cover%20of%20a%20young%20scavenger%20girl%20in%20a%20spacesuit%20standing%20on%20a%20wrecked%20asteroid%20with%20a%20glowing%20galaxy%20behind%2C%20space%20adventure%20mood%2C%20warm%20amber%20and%20teal%20nebula%20palette%2C%20clean%20cinematic%20composition%2C%20high%20detail&width=600&height=800&seq=series-09&orientation=portrait",
  },
  {
    id: "campus-detective",
    title: "校园侦探社",
    author: "薄荷推理",
    tags: ["校园", "悬疑"],
    rating: 9.0,
    chapters: 83,
    status: "连载中",
    update: "昨日更新",
    description:
      "五个性格迥异的少年少女组成侦探社，专破校园怪谈与离奇事件。推理严谨，笑点与悬念并存。",
    cover: "https://readdy.ai/api/search-image?query=stylized%20webtoon%20cover%20of%20five%20high%20school%20students%20grouped%20around%20a%20magnifying%20glass%20with%20mystery%20clues%20in%20a%20school%20lobby%2C%20detective%20youth%20mood%2C%20warm%20amber%20and%20charcoal%20palette%2C%20clean%20playful%20composition%2C%20high%20detail&width=600&height=800&seq=series-10&orientation=portrait",
  },
];

export const features = [
  {
    icon: "ri-window-line",
    title: "无弹窗阅读",
    desc: "页面纯净无广告干扰，沉浸式全屏阅读，不再被弹窗打断剧情。",
  },
  {
    icon: "ri-flashlight-line",
    title: "极速加载",
    desc: "智能压缩与分片加载技术，翻页即读，弱网环境下也能流畅体验。",
  },
  {
    icon: "ri-sword-line",
    title: "高清画质",
    desc: "原图级高清分镜，细节锐利、色彩还原，翻页缩放依旧清晰。",
  },
  {
    icon: "ri-arrow-left-right-line",
    title: "翻页顺畅",
    desc: "支持点击、滑动与方向键翻页，进度记忆自动续读，无缝衔接。",
  },
  {
    icon: "ri-zoom-in-line",
    title: "自由缩放",
    desc: "双指缩放、双击放大，配合分区浏览，任何手机屏幕都看得清。",
  },
  {
    icon: "ri-moon-line",
    title: "护眼模式",
    desc: "夜间模式与柔和背光，长时间追更也保护双眼，阅读更舒适。",
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqList: FaqItem[] = [
  {
    q: "韩漫在线需要注册账号才能阅读吗？",
    a: "不需要。韩漫在线的绝大多数热门韩漫都可以直接免费阅读，无需注册即可体验无弹窗、高清、极速加载的阅读服务。注册账号可以额外使用收藏书签、追更提醒与多端进度同步功能。",
  },
  {
    q: "为什么韩漫在线能做到无弹窗阅读？",
    a: "我们采用自主研发的纯净阅读内核，将页面渲染与内容加载分层处理，彻底屏蔽第三方弹窗与干扰广告，让你在浏览和翻页时全程专注剧情，不受任何打扰。",
  },
  {
    q: "高清画质下加载会不会很慢？",
    a: "不会。韩漫在线针对不同网络环境提供自适应清晰度，默认使用高清画质，同时通过分片预加载让翻页即到。即便网络一般，也能保证流畅阅读，不会出现长时间空白等待。",
  },
  {
    q: "翻页和缩放功能在手机上体验如何？",
    a: "韩漫在线完全适配手机、平板和电脑。支持点击翻页、滑动翻页与方向键翻页，双指即可自由缩放画面，双击可快速放大局部细节，缩放后依旧保持清晰，阅读十分顺手。",
  },
  {
    q: "如何收藏喜欢的韩漫并跟踪更新？",
    a: "登录账号后在作品详情页点击收藏按钮即可加入书架，韩漫在线会在作品更新时第一时间推送提醒，支持按最近更新、连载状态智能排序，追更不再错过。",
  },
  {
    q: "韩漫在线的阅读进度会同步到不同设备吗？",
    a: "会。只要使用同一账号登录，韩漫在线会自动记录你的阅读进度，并同步到手机、平板和电脑端。换设备继续阅读时，直接续读上次停下的位置，无缝衔接。",
  },
];

export const testimonials = [
  {
    name: "阿茶",
    role: "漫画重度读者",
    text: "用过好几个平台，只有韩漫在线的翻页体验最顺，点击一下就到下一页，无弹窗这点真的好评，追更完全停不下来。",
    star: 5,
  },
  {
    name: "小北",
    role: "通勤追更党",
    text: "地铁上信号一般，韩漫在线的高清图加载居然也不卡，缩放看细节特别清楚，是我通勤路上离不开的阅读伴侣。",
    star: 5,
  },
  {
    name: "澄澄",
    role: "收藏爱好者",
    text: "书签和进度同步做得太贴心了，手机看到一半换电脑继续看，直接接着上次的位置，体验非常流畅。",
    star: 5,
  },
];

export const ranking = [
  { rank: 1, title: "月落星沉", tag: "奇幻 · 恋爱", heat: "9.6" },
  { rank: 2, title: "都市异能者", tag: "都市 · 动作", heat: "9.3" },
  { rank: 3, title: "炼金术士的手札", tag: "奇幻 · 冒险", heat: "9.5" },
  { rank: 4, title: "夏日告白信", tag: "恋爱 · 校园", heat: "9.4" },
  { rank: 5, title: "时光恋人", tag: "恋爱 · 都市", heat: "9.3" },
  { rank: 6, title: "剑与契约", tag: "动作 · 冒险", heat: "9.2" },
];

export const readerPages = [
  {
    page: 1,
    cover:
      "https://readdy.ai/api/search-image?query=webtoon%20manhwa%20vertical%20panel%20of%20a%20dramatic%20moonlit%20forest%20with%20a%20heroine%20reaching%20for%20a%20glowing%20star%2C%20clean%20ink%20linework%2C%20warm%20amber%20and%20teal%20tones%2C%20vertical%20strip%20composition%2C%20high%20detail&width=900&height=1200&seq=reader-01&orientation=portrait",
  },
  {
    page: 2,
    cover:
      "https://readdy.ai/api/search-image?query=webtoon%20manhwa%20vertical%20panel%20of%20a%20close%20up%20conversation%20between%20two%20characters%20under%20a%20streetlight%2C%20expressive%20faces%2C%20clean%20ink%20linework%2C%20warm%20amber%20and%20charcoal%20tones%2C%20vertical%20strip%20composition%2C%20high%20detail&width=900&height=1200&seq=reader-02&orientation=portrait",
  },
];